ps-link {
  a {
    text-decoration: none;
  }
  a, a:visited, a:hover, a:active {
    color: inherit;
  }
}

.ds-link {
  padding-bottom: 2px;
  border-width: 0 0 1px 0;
  border-style: solid;

  &:hover {
    cursor: pointer;
  }
}

.ds-link {

  &__primary {
    color: $ds-color-mosegroenn;
    border-color: $ds-color-mosegroenn;

    &:hover {
      color: $ds-color-spiregroenn;
      background-color: $ds-color-mosegroenn;
    }
  }
  
  &__secondary {
    color: $ds-color-white;
    border-color: $ds-color-white;

    &:hover {
      color: $ds-color-spiregroenn;
      border-color: $ds-color-spiregroenn;
    }
  }
}
